import React, { useEffect, useState } from 'react';
import { Marker, InfoWindow, useNavermaps } from 'react-naver-maps';
import { getMarkerStyle } from '../utils/mapUtils';

function LiquefactionAssessmentMarker({ borehole, selected }) {
  
  const fillColor = borehole.liquefaction_assessment != null ? borehole.liquefaction_assessment === "평가 필요" ? "red" : "green" : "gray"
  const navermaps = useNavermaps();
  const markerIcon = {
    content: `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
        <circle cx="12" cy="12" r="10" fill="${fillColor}" stroke="${selected ? '#0000ff' : fillColor}" stroke-width="2" ${selected ? 'stroke-dasharray="4,2"' : ''} />
      </svg>`,
    size: new navermaps.Size(24, 24),
    anchor: new navermaps.Point(12, 12),
  };

  
  return (
    <>
      <Marker
        key={borehole.id}
        position={new navermaps.LatLng(borehole.grs80_x, borehole.grs80_y)}
        icon={markerIcon}
      />
    </>
  );
}

export default LiquefactionAssessmentMarker;